import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    cateLists: []
};
const getters = {
    manneCate: state => state.cateLists

};

const mutations = {
    MANNE_CATE_INFO(state, data) {
        state.cateLists = data
    }
};

const actions = {
    manneCate(context) {
        axiosGet(`crm/manne/cate`).then((response) => {
            context.commit('MANNE_CATE_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
